const { REACT_APP_FIGMA_API_URL } = process.env;
export async function fileQuery({ client, file }) {
  const { data } = await client.post(`figma/query/`, {
    url: `${REACT_APP_FIGMA_API_URL}/files/${file}`,
  });
  return data;
}
